import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Grid,
  Paper,
  Tooltip,
  Menu,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Table,
  Tooltip as Tooltip1,
  Button as Button1,
  Space,
  Popover,
  Checkbox,
  Empty,
} from "antd";
import {
  LockOutlined,
  EditOutlined,
  EyeOutlined,
  CloudUploadOutlined,
  HistoryOutlined,
  MoreOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import dayjs from "dayjs";

import invoiceApi from "../api/invoiceApi";
import invoiceTemplateApi from "../api/invoiceTemplateApi";

import InvoiceModal from "./InvoiceModal";
import InvoiceHistoryModal from "./InvoiceHistoryModal";
import ConfirmDialog from "../components/ConfirmDialog";
import AgreementModal from "./AgreementModal";

const invoiceStatus = [
  { value: -1, label: "Tất cả" },
  { value: 1, label: "Phiếu chưa có thông tin" },
  { value: 2, label: "Chưa có mã CQT" },
  { value: 3, label: "Chưa ký số" },
  { value: 4, label: "Chưa đồng bộ CQT" },
  { value: 5, label: "Đã đồng bộ CQT" },
  { value: 6, label: "Đã ký thuế chưa duyệt" },
  { value: 7, label: "Đã ký Phát hành HĐ thành công" },
  { value: 8, label: "Lỗi đồng bộ CQT" },
  { value: 9, label: "Có điều chỉnh hoá đơn" },
  { value: 10, label: "Có thay thế hoá đơn" },
  { value: 11, label: "Có lập thông báo sai sót hoá đơn" },
];

const pageNo = "HandleInvoiceErrorPage";

function HandleInvoiceErrorPage() {
  const user = useSelector((state) => state.auth.user);
  const roles = useSelector((state) => state.auth.roles) || null;
  const customerInfor =
    useSelector((state) => state.auth.customerInfor) || null;
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [anchorElRow, setAnchorElRow] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);

  const handleOpenRowMenu = (event, row) => {
    setAnchorElRow(event.currentTarget);
    setCurrentRow(row);
  };

  const handleCloseRowMenu = () => {
    setAnchorElRow(null);
    setCurrentRow(null);
  };

  const [openInvoiceHistoryModal, setOpenInvoiceHistoryModal] = useState(false);

  // --- State cho các tham số truy vấn thực tế được gửi lên API (query states) ---
  const [searchQuery, setSearchQuery] = useState({
    cusId: customerInfor.CusId,
    invoiceTemplateId: null,
    invoiceStatus: null,
    fromDate: dayjs(),
    toDate: dayjs(),
    searchKeyword: "",
    fromAmount: null,
    toAmount: null,
    isNormal: false,
    paymentMethod: "-1",
  });

  // --- State cho dữ liệu Table và phân trang ---
  const [invoices, setInvoices] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 1,
    pageSize: 20,
  });
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [loadingHoaDon, setLoadingHoaDon] = useState(false);

  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [editingInvoiceData, setEditingInvoiceData] = useState(null);

  const [invoiceTemplate, setInvoiceTemplate] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([
    { value: "-1", label: "Tất cả" },
  ]);
  const [totalInvoiceTmp, setTotalInvoiceTmp] = useState(0);
  const [totalInvoiceSync, setTotalInvoiceSync] = useState(0);
  const [totalInvoiceSign, setTotalInvoiceSign] = useState(0);
  const [totalInvoiceRemain, setTotalInvoiceRemain] = useState(0);

  const [summary, setSummary] = useState({
    TotalItemAmount: 0,
    TotalDiscountAmount: 0,
    TotalBeforeTax: 0,
    TotalVatAmount: 0,
    TotalAfterTax: 0,
  });
  const [confirmDialogState, setConfirmDialogState] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: () => {},
    onClose: () => {},
  });
  const [openAgreement, setOpenAgreement] = useState(false);

  // --- Hàm để tải danh sách chi nhánh và PTTT từ API ---
  useEffect(() => {
    async function fetchInvoiceTemplate() {
      try {
        const response = await invoiceTemplateApi.searchTemplates(
          customerInfor.CusId,
          "",
          0,
          100,
        );
        if (response.success) {
          setInvoiceTemplate((prev) => [
            { value: -1, label: "Tất cả" },
            ...response.data.result.map((x) => ({
              value: x.ItId,
              label: x.ItIsActive ? (
                x.signName
              ) : (
                <s style={{ textDecorationColor: "red" }}>
                  {x.signName + "(ngưng)"}
                </s>
              ),
            })),
          ]);
        } else {
          setInvoiceTemplate([{ value: -1, label: "Tất cả" }]);
          console.error("Error fetchInvoiceTemplate: " + response.message);
        }
      } catch (error) {
        setInvoiceTemplate([{ value: -1, label: "Tất cả" }]);
        console.error("Error fetchInvoiceTemplate: " + error.message);
      }
    }
    async function fetchPaymentMethod() {
      try {
        const response = await invoiceApi.GetAllPaymentMethod(
          customerInfor.CusId,
        );
        if (response.success) {
          setPaymentMethods(() => [
            { value: "-1", label: "Tất cả" },
            ...response.data.map((x) => ({
              value: x.PaymentMethod,
              label: x.PaymentMethod,
            })),
          ]);
        } else {
          setPaymentMethods([{ value: "-1", label: "Tất cả" }]);
          toast.error(response.message);
        }
      } catch (error) {
        setPaymentMethods([{ value: "-1", label: "Tất cả" }]);
        toast.error(error);
      }
    }
    fetchInvoiceTemplate();
    fetchPaymentMethod();
  }, [customerInfor.CusId]);

  // --- Hàm để tải danh sách hóa đơn từ API ---
  const SearchInvoices = useCallback(async (query, pagination) => {
    setLoadingHoaDon(true);
    try {
      const response = await invoiceApi.searchInvoices(
        query.cusId,
        query.invoiceTemplateId,
        query.searchKeyword,
        query.fromDate,
        query.toDate,
        pagination.page,
        pagination.pageSize,
        query.isNormal,
        query.invoiceStatus,
        query.fromAmount,
        query.toAmount,
        query.paymentMethod === "-1" ? null : query.paymentMethod,
      );
      if (response.success) {
        const mappedData = response.data.Invoices.map((invoice) => ({
          ...invoice,
          id: invoice.ReiId,
          ReiDate: invoice.ReiDate
            ? dayjs(invoice.ReiDate).format("DD/MM/YYYY")
            : "",
        }));

        setInvoices(mappedData);
        setTotalRowCount(parseInt(response.pagination.totalRecords || 0, 10));
        setTotalInvoiceTmp(response.data.TotalInvoice.TotalInvoiceTmp);
        setTotalInvoiceSync(response.data.TotalInvoice.TotalInvoiceSync);
        setTotalInvoiceSign(response.data.TotalInvoice.TotalInvoiceSign);
        setTotalInvoiceRemain(response.data.TotalInvoice.TotalInvoiceRemain);
        setSummary(response.data.Summary);
      } else {
        console.error("API hóa đơn trả về dữ liệu không hợp lệ:", response);
        setInvoices([]);
        setTotalRowCount(0);
        setSummary({
          TotalItemAmount: 0,
          TotalDiscountAmount: 0,
          TotalBeforeTax: 0,
          TotalVatAmount: 0,
          TotalAfterTax: 0,
        });
      }
    } catch (error) {
      console.error("Lỗi khi tải danh sách hóa đơn:", error);
      setInvoices([]);
      setTotalRowCount(0);
      setSummary({
        TotalItemAmount: 0,
        TotalDiscountAmount: 0,
        TotalBeforeTax: 0,
        TotalVatAmount: 0,
        TotalAfterTax: 0,
      });
    } finally {
      setLoadingHoaDon(false);
      setRowSelectionModel([]);
    }
  }, []);

  const openInvoiceModalWithData = async (reiId, specialStatus = null) => {
    setLoadingHoaDon(true);
    try {
      const response = await invoiceApi.getInvoiceData(reiId);
      if (response.success && response.data) {
        let dataToEdit = { ...response.data };
        if (specialStatus !== null) {
          const tempResponse =
            await invoiceTemplateApi.GetInvoiceTemplateActive(dataToEdit.ReiId);
          const temp = tempResponse.data[0];

          if (specialStatus === 2) {
            dataToEdit = {
              ...dataToEdit,
              ReiId: null,
              ReiParentId: reiId,
              ReiStatus: specialStatus,
              ReiInvoiceNum: "",
              ReiEInvoiceId: "",
              ReiEInvoiceKey: null,
              ReiEStatus: 1,
              ReiLookupKey: "",
              ReiTaxAuthorityCode: "",
              ReiInvoiceNumParent: dataToEdit.ReiInvoiceNum,
              ReiEInvoiceIdParent: dataToEdit.ReiEInvoiceId,
              ReiDateParent: dataToEdit.ReiDate,
              ReiTaxAuthorityCodeParent: dataToEdit.ReiTaxAuthorityCode,
              ReiLookupKeyParent: dataToEdit.ReiLookupKey,
              ReiTemplateParent: dataToEdit.ReiTemplate,
              ReiSignParent: dataToEdit.ReiSign,
              ReiDate: dayjs(),
              ReiSign: temp.ItSign,
              ReiTemplate: temp.ItTemplate,
              ItId: temp.ItId,
            };
          } else {
            dataToEdit = {
              ...dataToEdit,
              ReiId: null,
              ReiParentId: reiId,
              ReiStatus: specialStatus,
              ReiInvoiceNum: "",
              ReiEInvoiceId: "",
              ReiEInvoiceKey: null,
              ReiEStatus: 1,
              ReiLookupKey: "",
              ReiTaxAuthorityCode: "",
              ReiItemAmount: 0,
              ReiDiscountAmount: 0,
              ReiAmountBeforeTax: 0,
              ReiVatAmount: 0,
              ReiAmountAfterTax: 0,
              ReiInvoiceNumParent: dataToEdit.ReiInvoiceNum,
              ReiEInvoiceIdParent: dataToEdit.ReiEInvoiceId,
              ReiDateParent: dataToEdit.ReiDate,
              ReiTaxAuthorityCodeParent: dataToEdit.ReiTaxAuthorityCode,
              ReiLookupKeyParent: dataToEdit.ReiLookupKey,
              ReiTemplateParent: dataToEdit.ReiTemplate,
              ReiSignParent: dataToEdit.ReiSign,
              Details: [],
              ReiDate: dayjs(),
              ReiSign: temp.ItSign,
              ReiTemplate: temp.ItTemplate,
              ItId: temp.ItId,
            };
          }
        }
        setEditingInvoiceData(dataToEdit);
        setIsInvoiceModalOpen(true);
      } else {
        toast.error(response.message || "Không tìm thấy thông tin hóa đơn.");
      }
    } catch (error) {
      console.error("Lỗi khi tải hóa đơn:", error);
      toast.error("Đã xảy ra lỗi khi tải thông tin hóa đơn.");
    } finally {
      setLoadingHoaDon(false);
    }
  };

  const handleClickReplaceInvoice = async () => {
    let row = currentRow;
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo &&
          x.CtrNo === "btnReplaceInvoice" &&
          x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền tạo hoá đơn thay thế.");
      return;
    }

    if (row.ReiStatus === 3 || row.ReiStatus === 4 || row.ReiStatus === 5) {
      toast.warning("Không thể thay thế hoá đơn điều chỉnh.");
      return;
    }
    if (!row.ReiInvoiceNum) {
      toast.warning("Hoá đơn chưa có số không thể thay thế.");
      return;
    }
    const checkChild = await invoiceApi.CheckExistChild(row.ReiId, 2);
    if (checkChild.success) toast.error(checkChild.message);
    else {
      openInvoiceModalWithData(row.ReiId, 2);
    }
  };

  const handleCloseInvoiceModal = () => {
    setIsInvoiceModalOpen(false);
    setEditingInvoiceData(null);
    handleCloseRowMenu();
    SearchInvoices(searchQuery, paginationModel);
  };

  const handleSyncInvoice = async (ReiId) => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo &&
          x.CtrNo === "btnSyncInvoice" &&
          x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền đồng bộ hoá đơn.");
      return;
    }
    try {
      const response = await invoiceApi.syncInvoice(ReiId);
      if (response.success) {
        toast.success("Đồng bộ hóa đơn thành công!");
        SearchInvoices(searchQuery, paginationModel);
      } else {
        toast.error(response.message || "Lỗi khi đồng bộ hóa đơn.");
      }
    } catch (error) {
      console.error("Lỗi khi đồng bộ hóa đơn:", error);
      toast.error("Đã xảy ra lỗi khi đồng bộ hóa đơn.");
    }
  };

  useEffect(() => {
    SearchInvoices(searchQuery, paginationModel);
  }, [SearchInvoices]);

  const handleEditInvoice = (ReiId) => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo && x.CtrNo === "btnEdit" && x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền sửa hoá đơn.");
      return;
    }
    openInvoiceModalWithData(ReiId);
  };

  const handleRemoveInvoice = async (status) => {
    if (rowSelectionModel.length <= 0) {
      toast.warning("Vui lòng chọn phiếu để xoá.");
      return;
    }
    if (status === 0) {
      setConfirmDialogState({
        open: true,
        title: "Xóa phiếu",
        content: "Bạn chắc chắn muốn xóa các phiếu này?",
        onConfirm: () => {
          handleRemoveInvoice(1);
          setConfirmDialogState((prev) => ({
            ...prev,
            open: false,
          }));
        },
        onClose: () =>
          setConfirmDialogState((prev) => ({
            ...prev,
            open: false,
          })),
      });
      return;
    }
    try {
      const response = await invoiceApi.removeInvoice(rowSelectionModel);
      if (response.success) {
        toast.success("Xoá phiếu thành công!");
        SearchInvoices(searchQuery, paginationModel);
      } else {
        toast.error(response.message || "Lỗi khi xoá phiếu.");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleMemorandumOfAgreement = async () => {
    try {
      setOpenAgreement(true);
      handleCloseRowMenu();
    } catch (error) {
      toast.error(error);
    }
  };

  // Cột cho Antd Table
  const allColumns = useMemo(() => {
    return [
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Trạng thái</div>
            <div>Ngày hóa đơn</div>
          </div>
        ),
        key: "ReiEStatusAndReiDate",
        width: 120,
        align: "center",
        label: "Trạng thái & Ngày HĐ",
        render: (_, record) => (
          <div className="cell-column cell-center">
            <div>{record.ReiEStatusName}</div>
            <div>{record.ReiDate}</div>
          </div>
        ),
      },
      {
        title: "Số hoá đơn",
        dataIndex: "ReiInvoiceNum",
        key: "ReiInvoiceNum",
        align: "center",
        width: 100,
        label: "Số hoá đơn",
      },
      {
        title: "Mã của CQT",
        dataIndex: "ReiTaxAuthorityCode",
        key: "ReiTaxAuthorityCode",
        align: "center",
        width: 130,
        label: "Mã CQT",
        render: (text) => (
          <span
            style={{
              wordBreak: "break-word",
              whiteSpace: "normal",
              fontSize: "14px",
            }}
          >
            {text}
          </span>
        ),
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Ký hiệu & Mẫu</div>
            <div>Chi nhánh</div>
          </div>
        ),
        key: "ReiSign_Template",
        width: 240,
        align: "center",
        label: "Ký hiệu, Mẫu & Chi nhánh",
        render: (_, record) => {
          const value1 = (record.ReiTemplate || "") + (record.ReiSign || "");
          const value2 = record.ItLocation;
          const content = (
            <div className="cell-column cell-center" style={{ width: "100%" }}>
              <div>{value1}</div>
              <div>{value2}</div>
            </div>
          );
          return (
            <Tooltip title={content} mouseenterdelay={0.4} placement="top">
              {content}
            </Tooltip>
          );
        },
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Tên người mua</div>
            <div>Mã số thuế</div>
          </div>
        ),
        key: "ReiBuyerName",
        width: 300,
        label: "Thông tin người mua",
        render: (_, record) => {
          const value1 = record.BuyerName;
          const value2 = record.ReiTaxId;
          const content = (
            <div className="cell-column">
              <div>{value1}</div>
              <div>{value2}</div>
            </div>
          );
          return (
            <Tooltip title={content} mouseenterdelay={0.4} placement="top">
              {content}
            </Tooltip>
          );
        },
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Thành tiền</div>
            <div>Chiết khấu</div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalItemAmount?.toLocaleString("vi-VN")}
            </div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalDiscountAmount?.toLocaleString("vi-VN")}
            </div>
          </div>
        ),
        key: "ReiItemAmount_Discount",
        width: 120,
        align: "right",
        label: "Thành tiền & Chiết khấu",
        render: (_, record) => (
          <div className="cell-column">
            <div>{record.ReiItemAmount?.toLocaleString("vi-VN")}</div>
            <div>{record.ReiDiscountAmount?.toLocaleString("vi-VN")}</div>
          </div>
        ),
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Tiền trước thuế</div>
            <div>Tiền thuế</div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalBeforeTax?.toLocaleString("vi-VN")}
            </div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalVatAmount?.toLocaleString("vi-VN")}
            </div>
          </div>
        ),
        key: "ReiAmountBeforeTax",
        width: 120,
        align: "right",
        label: "Tiền trước thuế & Tiền thuế",
        render: (_, record) => (
          <div className="cell-column">
            <div>{record.ReiAmountBeforeTax?.toLocaleString("vi-VN")}</div>
            <div>{record.ReiVatAmount?.toLocaleString("vi-VN")}</div>
          </div>
        ),
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Tổng cộng</div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalAfterTax?.toLocaleString("vi-VN")}
            </div>
          </div>
        ),
        dataIndex: "ReiAmountAfterTax",
        key: "ReiAmountAfterTax",
        align: "right",
        width: 120,
        label: "Tổng cộng",
        render: (value) => (value != null ? value.toLocaleString("vi-VN") : ""),
      },
      {
        title: "Ghi chú",
        dataIndex: "ReiContent",
        key: "ReiContent",
        align: "center",
        width: 250,
        label: "Ghi chú",
      },
      {
        title: "Ghi chú phiếu",
        dataIndex: "ReiDescription",
        key: "ReiDescription",
        align: "center",
        width: 250,
        label: "Ghi chú phiếu",
      },
      {
        title: "Mã bill",
        dataIndex: "TkBillNo",
        key: "TkBillNo",
        align: "center",
        width: 150,
        label: "Mã bill",
      },
      {
        title: "Tờ HĐ",
        dataIndex: "StatusName",
        key: "StatusName",
        align: "center",
        width: 120,
        label: "Tờ HĐ",
      },
      {
        title: "Chức năng",
        key: "actions",
        width: 200,
        align: "center",
        fixed: "right",
        render: (_, record) => (
          <Space size="small">
            {record.ReiIsApproved && (
              <Tooltip1 title="Phiếu này đang bị khoá sẽ không thể chỉnh sửa thông tin từ POS bán hàng.">
                <Button1
                  type="text"
                  shape="circle"
                  size="small"
                  icon={<LockOutlined />}
                />
              </Tooltip1>
            )}

            <Tooltip1 title="Sửa thông tin">
              <Button1
                type="text"
                shape="circle"
                size="small"
                color="primary"
                variant="text"
                icon={<EditOutlined />}
                onClick={() => handleEditInvoice(record.ReiId)}
              />
            </Tooltip1>

            <Tooltip1 title="Xem bảng kê">
              <Button1
                type="text"
                shape="circle"
                size="small"
                color="primary"
                variant="text"
                icon={<EyeOutlined />}
              />
            </Tooltip1>

            <Tooltip1 title="Đồng bộ hoá đơn điện tử">
              <Button1
                type="text"
                shape="circle"
                size="small"
                color="primary"
                variant="text"
                icon={<CloudUploadOutlined />}
                onClick={() => handleSyncInvoice(record.ReiId)}
              />
            </Tooltip1>

            <Tooltip1 title="Xem lịch sử">
              <Button1
                type="text"
                shape="circle"
                size="small"
                color="primary"
                variant="text"
                icon={<HistoryOutlined />}
                onClick={() => {
                  setOpenInvoiceHistoryModal(true);
                  setCurrentRow(record);
                }}
              />
            </Tooltip1>

            <Tooltip1 title="Thêm">
              <Button1
                type="text"
                shape="circle"
                size="small"
                color="primary"
                variant="text"
                icon={<MoreOutlined />}
                onClick={(e) => handleOpenRowMenu(e, record)}
              />
            </Tooltip1>
          </Space>
        ),
      },
    ];
  }, [summary]);

  // --- QUẢN LÝ STATE ẨN HIỆN CỘT ---
  const [visibleColumns, setVisibleColumns] = useState(
    allColumns.map((col) => col.key),
  );
  const [columnPopoverOpen, setColumnPopoverOpen] = useState(false);

  const filterableColumns = allColumns.filter((col) => col.label);

  const columnToggleMenu = (
    <div
      style={{
        maxHeight: "300px",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Checkbox.Group
        value={visibleColumns}
        onChange={(checkedValues) => setVisibleColumns(checkedValues)}
        style={{ display: "flex", flexDirection: "column", gap: "6px" }}
      >
        {filterableColumns.map((col) => (
          <Checkbox key={col.key} value={col.key}>
            {col.label}
          </Checkbox>
        ))}
      </Checkbox.Group>
    </div>
  );

  const displayedColumns = useMemo(() => {
    return allColumns
      .filter((col) => !col.label || visibleColumns.includes(col.key))
      .map((col) => {
        if (col.key === "actions") {
          return {
            ...col,
            title: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                }}
              >
                <span>Chức năng</span>
                <div onClick={(e) => e.stopPropagation()}>
                  <Popover
                    content={
                      <div onClick={(e) => e.stopPropagation()}>
                        {columnToggleMenu}
                      </div>
                    }
                    title="Cấu hình ẩn/hiện cột"
                    trigger="click"
                    placement="bottomRight"
                    getPopupContainer={() => document.body}
                    destroyTooltipOnHide={false}
                  >
                    <Tooltip1 title="Ẩn/Hiện cột">
                      <Button1
                        type="primary"
                        icon={<SettingOutlined />}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                    </Tooltip1>
                  </Popover>
                </div>
              </div>
            ),
          };
        }
        return col;
      });
  }, [visibleColumns, allColumns, columnToggleMenu, columnPopoverOpen]);

  const rowSelection = {
    selectedRowKeys: rowSelectionModel,
    onChange: (newSelectedRowKeys) => {
      setRowSelectionModel(newSelectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: record.ReiEStatus === 4,
    }),
  };

  const getRowClassName = (record) => {
    if (record.ReiEStatus === 4) return "antd-row-sign";
    return "antd-row-default";
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          p: 1,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 64px)",
        }}
      >
        {/* Khung tìm kiếm */}
        <Paper elevation={3} sx={{ p: 2, mb: 2, display: "flex" }}>
          <Grid container spacing={1} alignItems="center" sx={{ flex: 1 }}>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                select
                label="Ký hiệu hoá đơn"
                fullWidth
                value={searchQuery.invoiceTemplateId ?? -1}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    invoiceTemplateId:
                      e.target.value === -1 ? null : e.target.value,
                  }))
                }
                size="small"
              >
                {invoiceTemplate.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                select
                label="Trạng thái hoá đơn"
                fullWidth
                value={searchQuery?.invoiceStatus ?? -1}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    invoiceStatus:
                      e.target.value === -1 ? null : e.target.value,
                  }))
                }
                size="small"
              >
                {invoiceStatus.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                select
                label="Hình thức thanh toán"
                fullWidth
                value={searchQuery?.paymentMethod ?? "-1"}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    paymentMethod: e.target.value,
                  }))
                }
                size="small"
              >
                {paymentMethods.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <DatePicker
                label="Từ ngày"
                format="DD/MM/YYYY"
                value={searchQuery.fromDate}
                onChange={(newValue) =>
                  setSearchQuery((prev) => ({ ...prev, fromDate: newValue }))
                }
                renderInput={(params) => <TextField {...params} fullWidth />}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <DatePicker
                label="Đến ngày"
                format="DD/MM/YYYY"
                value={searchQuery.toDate}
                onChange={(newValue) =>
                  setSearchQuery((prev) => ({ ...prev, toDate: newValue }))
                }
                renderInput={(params) => <TextField {...params} fullWidth />}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <Tooltip
                title="Bạn có thể nhập Số hoá đơn, Mã số thuế, Tên người mua, Mã CQT, Mã bill"
                arrow
              >
                <TextField
                  label="Từ khoá (Số HĐ, MST, Người mua, Mã CQT, Mã bill)"
                  fullWidth
                  value={searchQuery.searchKeyword}
                  onChange={(e) =>
                    setSearchQuery((prev) => ({
                      ...prev,
                      searchKeyword: e.target.value,
                    }))
                  }
                  size="small"
                />
              </Tooltip>
            </Grid>

            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                label="Tổng tiền lớn hơn"
                type="number"
                fullWidth
                value={searchQuery.fromAmount ?? ""}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    fromAmount: e.target.value,
                  }))
                }
                size="small"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                label="Tổng tiền nhỏ hơn"
                type="number"
                fullWidth
                value={searchQuery.toAmount ?? ""}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    toAmount: e.target.value,
                  }))
                }
                size="small"
              />
            </Grid>
            <Grid>
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={() => {
                  setPaginationModel({
                    page: 1,
                    pageSize: paginationModel.pageSize,
                  });
                  SearchInvoices(searchQuery, {
                    page: 1,
                    pageSize: paginationModel.pageSize,
                  });
                }}
                size="large"
              >
                Tìm kiếm
              </Button>
            </Grid>
          </Grid>
        </Paper>
        <Box
          sx={{ mb: 1, display: "flex", justifyContent: "flex-end", gap: 1 }}
        >
          <Button
            variant="contained"
            color="error"
            onClick={() => handleRemoveInvoice(0)}
          >
            Xoá phiếu nháp
          </Button>
        </Box>

        {/* Antd Table hiển thị danh sách hóa đơn */}
        <div className="table-container" style={{ width: "100%" }}>
          <Table
            size="small"
            columns={displayedColumns}
            dataSource={invoices}
            loading={loadingHoaDon}
            rowKey="ReiId"
            rowSelection={rowSelection}
            rowClassName={getRowClassName}
            bordered
            scroll={{
              x: "max-content",
              y: "calc(100vh - 405px)",
            }}
            pagination={{
              current: paginationModel.page,
              pageSize: paginationModel.pageSize,
              total: totalRowCount,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100", "200", "500", "1000"],
              onChange: (page, pageSize) => {
                setPaginationModel({ page, pageSize });
                SearchInvoices(searchQuery, { page, pageSize });
              },
              showTotal: (total) => {
                const selectedCount = rowSelectionModel?.length || 0;
                return (
                  <div className="pagination-wrapper-layout">
                    <div className="selected-status-box">
                      {selectedCount > 0 && (
                        <span
                          style={{
                            backgroundColor: "#e6f7ff",
                            color: "#1890ff",
                            padding: "4px 12px",
                            borderRadius: "4px",
                            fontSize: "13px",
                            fontWeight: 500,
                            display: "inline-block",
                          }}
                        >
                          Đã chọn <strong>{selectedCount}</strong> dòng
                        </span>
                      )}
                    </div>
                    <div className="total-result-text">
                      Tổng số <strong>{total}</strong> kết quả trong{" "}
                      <strong>
                        {Math.ceil(total / paginationModel.pageSize)}
                      </strong>{" "}
                      trang
                    </div>
                  </div>
                );
              },
              locale: { items_per_page: "/ trang" },
            }}
            styles={{
              body: {
                fontSize: "14px",
              },
            }}
            className="custom-antd-table"
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Không có dữ liệu"
                />
              ),
            }}
          />

          <style>{`
  /* --- 1. CSS CHỈNH MÀU SẮC DÒNG VÀ ĐƯỜNG VIỀN KHÓA CỘT --- */
  .custom-antd-table .antd-row-default td { color: #bb5d00ff !important; }
  .custom-antd-table .antd-row-sign td { color: #0a0404ff !important; }
  .custom-antd-table .ant-table-cell-fix-right { background-color: #ffffff !important; box-shadow: -4px 0 8px -2px rgba(0,0,0,0.1) !important; }
  .custom-antd-table .ant-table-thead > tr > th 
  { height: 70px; 
    padding: 4px !important; 
    font-weight: bold !important; /* hoặc 600 nếu muốn đậm vừa */
    color: #000000 !important;   /* Đảm bảo màu chữ đen rõ nét */ 
  }

  /* --- 2. CSS ÉP CHIỀU CAO LẤP ĐẦY KHI TRỐNG DỮ LIỆU --- */
  .custom-antd-table .ant-table-placeholder { height: calc(100vh - 430px) !important; }
  .custom-antd-table .ant-table-placeholder .ant-table-expanded-row-fixed { height: 100%; display: flex; align-items: center; justify-content: center; }

  /* Cố định chiều cao thân bảng: Dù có 1 dòng hay nhiều dòng, bảng luôn giữ nguyên chiều cao chuẩn */
  .custom-antd-table .ant-table-body {
    min-height: calc(100vh - 420px) !important;
    height: calc(100vh - 420px) !important;
  }
  /* Giảm padding trên/dưới từ 8px xuống còn 3px hoặc 4px */
  .custom-antd-table .ant-table-tbody > tr > td {
    padding: 3px 8px !important;
  }
  /* --- 3. FIX SỰ CỐ BỊ ĐẨY XUỐNG DÒNG (ĐỒNG PHẲNG PAGINATION & SELECTION) --- */
  .custom-antd-table .ant-pagination {
    display: flex !important;
    flex-flow: row nowrap !important;
    justify-content: flex-end !important;
    align-items: center !important;
    margin-top: 16px !important;
    width: 100% !important;
  }

  .custom-antd-table .ant-pagination-total-text {
    flex-grow: 1 !important;
    margin-right: 0 !important;
    padding-right: 16px;
    height: 32px !important;
  }

  .pagination-wrapper-layout {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    width: 100% !important;
  }

  .pagination-wrapper-layout .selected-status-box {
    flex-shrink: 0;
  }

  .pagination-wrapper-layout .total-result-text {
    margin-left: auto !important;
    white-space: nowrap !important;
  }

  .custom-antd-table .ant-pagination-item,
  .custom-antd-table .ant-pagination-prev,
  .custom-antd-table .ant-pagination-next,
  .custom-antd-table .ant-pagination-options {
    flex-shrink: 0 !important;
  }
`}</style>
        </div>

        <InvoiceModal
          open={isInvoiceModalOpen}
          onClose={handleCloseInvoiceModal}
          initialData={editingInvoiceData}
        />
        <InvoiceHistoryModal
          open={openInvoiceHistoryModal}
          onClose={() => setOpenInvoiceHistoryModal(false)}
          reiId={currentRow?.ReiId}
        />
      </Box>

      <Menu
        anchorEl={anchorElRow}
        open={Boolean(anchorElRow)}
        onClose={handleCloseRowMenu}
      >
        <MenuItem onClick={handleClickReplaceInvoice}>Thay thế lại</MenuItem>
        <MenuItem onClick={handleCloseRowMenu}>Giải trình</MenuItem>
        <MenuItem onClick={handleMemorandumOfAgreement}>
          Lập biên bản thoả thuận
        </MenuItem>
      </Menu>

      <ConfirmDialog
        open={confirmDialogState.open}
        title={confirmDialogState.title}
        content={confirmDialogState.content}
        onConfirm={confirmDialogState.onConfirm}
        onClose={confirmDialogState.onClose}
      />
      <AgreementModal
        open={openAgreement}
        handleClose={() => setOpenAgreement(false)}
        reiId={currentRow?.ReiId}
      />
    </LocalizationProvider>
  );
}

export default HandleInvoiceErrorPage;
